import { BottomSheetDialog } from '@medely/web-components';
import React from 'react';
import useDevice from '@mp/hooks/useDevice.web';
import { CancelAssignmentModalProps } from './interface';

export const CancelAssignmentModal = ({
  open,
  onClose,
  content,
  title,
  backButton,
}: CancelAssignmentModalProps) => {
  const isDesktop = useDevice() === 'desktop';

  return (
    <BottomSheetDialog
      open={open}
      onClose={onClose}
      title={title}
      content={content}
      actions={backButton}
      isDesktop={isDesktop}
    />
  );
};
